module.exports = __webpack_public_path__ + "img/scroll-bg-4.0ae18762.png";